module.exports = __webpack_public_path__ + "img/google.20f9dbea.png";